import IconPlus from '@/components/assets/icon_plus.svg'
import IconViverseLogo from '@/components/assets/icon_viverse_logo.svg'
import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form'
import { WorldSettingsFormValues } from '@/hooks/useWorldSettingsFormSchema'
import positionBackgroundImage from '@/public/images/position-background-default.png'
import { LogoPosition } from '@/services/cms'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useFormContext } from 'react-hook-form'

export type WorldSettingLogoOverlayTabProps = {
  handleLogoOverlayPositionChange: (position: LogoPosition) => void
}

const allPositions: LogoPosition[] = [
  'top-left',
  'top-center',
  'top-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
]
const positionClassNames: Record<LogoPosition, string> = {
  'top-left': 'top-2 left-2.5',
  'top-center': 'top-2 left-1/2 -translate-x-1/2',
  'top-right': 'top-2 right-2.5',
  'bottom-left': 'bottom-2 left-2.5',
  'bottom-center': 'bottom-2 left-1/2 -translate-x-1/2',
  'bottom-right': 'bottom-2 right-2.5',
}

const WorldSettingLogoOverlayTab = ({
  handleLogoOverlayPositionChange,
}: WorldSettingLogoOverlayTabProps) => {
  const t = useTranslations()
  const form = useFormContext<WorldSettingsFormValues>()

  return (
    <div className="flex w-full flex-col">
      <div className="md:subheader-1 subheader-2 mb-2 md:mb-4">
        {t('profile-page.my-worlds-card-settings-customize-placement')}
      </div>
      <p className="text-vive-primary-30 body-2">
        {t('profile-page.my-worlds-card-settings-customize-placement-caption')}
      </p>

      <div className="mt-6 flex w-full flex-col md:mt-8">
        <FormField
          control={form.control}
          name="logoOverlayPosition"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="subheader-3 text-vive-primary-20">
                {t('profile-page.my-worlds-card-settings-position-select')}
              </FormLabel>
              <FormControl>
                <div className="top mt-2 flex flex-col">
                  <div className="max-md:h-[208.24px]} relative flex h-[178px] w-full max-w-[306px] flex-col items-center justify-between self-stretch overflow-hidden rounded-lg px-[10px] py-[8px] backdrop-blur-[50px]">
                    <Image
                      src={positionBackgroundImage}
                      alt="position background"
                      fill
                      className="object-cover"
                      priority
                    />
                    {allPositions.map((position) => {
                      const isLogo = position === field.value
                      return (
                        <div
                          key={position}
                          className={`absolute cursor-pointer ${positionClassNames[position]}`}
                          onClick={() => {
                            if (!isLogo) {
                              handleLogoOverlayPositionChange(position)
                            }
                          }}
                        >
                          {isLogo ? (
                            <IconViverseLogo width={77} height={20} />
                          ) : (
                            <IconPlus
                              width={20}
                              height={20}
                              className="fill-vive-primary-20 hover:bg-vive-white/15 rounded-full p-1"
                            />
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </FormControl>
            </FormItem>
          )}
        ></FormField>
      </div>
    </div>
  )
}
export default WorldSettingLogoOverlayTab
